import { Typography } from '@material-ui/core';
import React from 'react';

import { IReactChildren, IWithStylesProps } from '~/src/dash/types/props';
import { decorate } from '~/src/dash/utils/decorator';
import { growGrid, growGridLeft, growGridRight } from '~/src/dash/utils/material-dashboard-react';

export const H1 = decorate(
  {
    styles: (theme: any) => ({
      cont: {
        marginBottom: theme.spacing.unit * 4,
      },
    }),
  },
  function ({ classes, children }: IWithStylesProps & IReactChildren) {
    return (
      <div className={classes.cont}>
        <Typography variant='h4' gutterBottom>
          {children}
        </Typography>
      </div>
    );
  },
);

export const H2 = decorate(
  {
    styles: (theme: any) => ({
      cont: {
        marginBottom: theme.spacing.unit * 4,
      },
    }),
  },
  function ({ classes, children }: IWithStylesProps & IReactChildren) {
    return (
      <div className={classes.cont}>
        <Typography variant='h5' gutterBottom>
          {children}
        </Typography>
      </div>
    );
  },
);

export const HeadingCategory = decorate(
  {
    styles: () => ({
      cont: {
        marginBottom: '20px',
      },
    }),
  },
  function ({ classes, children }: IWithStylesProps & IReactChildren) {
    return (
      <div className={classes.cont}>
        <Typography variant='h6' gutterBottom>
          {children}
        </Typography>
      </div>
    );
  },
);

export const HeadingCategorySm = decorate(
  {
    styles: () => ({
      cont: {
        marginBottom: '10px',
      },
    }),
  },
  function ({ classes, children }: IWithStylesProps & IReactChildren) {
    return (
      <div className={classes.cont}>
        <Typography variant='h6' gutterBottom>
          {children}
        </Typography>
      </div>
    );
  },
);

export const H3 = decorate({}, function ({ children }: IWithStylesProps & IReactChildren) {
  return (
    <div>
      <Typography variant='h6' gutterBottom>
        {children}
      </Typography>
    </div>
  );
});

export interface IRow extends IWithStylesProps {
  left?: React.ElementType;
  right?: React.ElementType;

  RowProps?: any;
  RowLeftProps?: any;
  RowRightProps?: any;
}

export const RowButton = decorate(
  {
    styles: () => ({
      growGrid,
      growGridLeft,
      growGridRight,
    }),
  },
  function ({ classes, left, right, RowProps, RowLeftProps, RowRightProps }: IRow) {
    return (
      <div className={classes.growGrid} {...RowProps}>
        <div className={classes.growGridLeft} {...RowLeftProps}>
          {left}
        </div>
        <div className={classes.growGridRight} {...RowRightProps}>
          {right}
        </div>
      </div>
    );
  },
);
